export * from './lib/icons/app-icons/icon-registry';
